// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/equipment_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/activity/equipment_preferences.proto.
 */
export const file_proto_model_booking_activity_equipment_preferences = /*@__PURE__*/
  fileDesc("Cjhwcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L2VxdWlwbWVudF9wcmVmZXJlbmNlcy5wcm90bxIGY2FybWVuIrIFChRFcXVpcG1lbnRQcmVmZXJlbmNlcxI3ChNlcXVpcG1lbnRfcHJvdmlzaW9uGAEgASgOMhouY2FybWVuLkVxdWlwbWVudFByb3Zpc2lvbhIaChJwZXJzb25hbF9lcXVpcG1lbnQYAiADKAkSRwoRZXF1aXBtZW50X3JlbnRhbHMYAyADKAsyLC5jYXJtZW4uRXF1aXBtZW50UHJlZmVyZW5jZXMuRXF1aXBtZW50UmVudGFsEkEKC3NpemluZ19pbmZvGAQgASgLMiwuY2FybWVuLkVxdWlwbWVudFByZWZlcmVuY2VzLkVxdWlwbWVudFNpemluZxIcChRzcGVjaWFsX3JlcXVpcmVtZW50cxgFIAMoCRptCg9FcXVpcG1lbnRSZW50YWwSFgoOZXF1aXBtZW50X3R5cGUYASABKAkSFwoPcHJlZmVycmVkX2JyYW5kGAIgASgJEgwKBHNpemUYAyABKAkSGwoTaW5zdXJhbmNlX3JlcXVlc3RlZBgEIAEoCBqrAgoPRXF1aXBtZW50U2l6aW5nEhIKCnNoaXJ0X3NpemUYASABKAkSEQoJc2hvZV9zaXplGAIgASgJEhIKCmdsb3ZlX3NpemUYAyABKAkSEwoLaGVsbWV0X3NpemUYBCABKAkSEQoJaGVpZ2h0X2NtGAUgASgBEhEKCXdlaWdodF9rZxgGIAEoARJlChVhY3Rpdml0eV9tZWFzdXJlbWVudHMYByADKAsyRi5jYXJtZW4uRXF1aXBtZW50UHJlZmVyZW5jZXMuRXF1aXBtZW50U2l6aW5nLkFjdGl2aXR5TWVhc3VyZW1lbnRzRW50cnkaOwoZQWN0aXZpdHlNZWFzdXJlbWVudHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBKs0BChJFcXVpcG1lbnRQcm92aXNpb24SIwofRVFVSVBNRU5UX1BST1ZJU0lPTl9VTlNQRUNJRklFRBAAEikKJUVRVUlQTUVOVF9QUk9WSVNJT05fUFJPVklERVJfU1VQUExJRUQQARIoCiRFUVVJUE1FTlRfUFJPVklTSU9OX1BBUlRJQ0lQQU5UX09XTlMQAhIdChlFUVVJUE1FTlRfUFJPVklTSU9OX01JWEVEEAMSHgoaRVFVSVBNRU5UX1BST1ZJU0lPTl9SRU5UQUwQBEIwWi5naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9ib29raW5nYgZwcm90bzM");

/**
 * Describes the message carmen.EquipmentPreferences.
 * Use `create(EquipmentPreferencesSchema)` to create a new message.
 */
export const EquipmentPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_equipment_preferences, 0);

/**
 * Describes the message carmen.EquipmentPreferences.EquipmentRental.
 * Use `create(EquipmentPreferences_EquipmentRentalSchema)` to create a new message.
 */
export const EquipmentPreferences_EquipmentRentalSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_equipment_preferences, 0, 0);

/**
 * Describes the message carmen.EquipmentPreferences.EquipmentSizing.
 * Use `create(EquipmentPreferences_EquipmentSizingSchema)` to create a new message.
 */
export const EquipmentPreferences_EquipmentSizingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_equipment_preferences, 0, 1);

/**
 * Describes the enum carmen.EquipmentProvision.
 */
export const EquipmentProvisionSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_equipment_preferences, 0);

/**
 * @generated from enum carmen.EquipmentProvision
 */
export const EquipmentProvision = /*@__PURE__*/
  tsEnum(EquipmentProvisionSchema);

